/**
 * Google Maps JS Places library lazy loader（MAP-GOOGLE-E2 / E3D / C1）。
 * 重用 shared googleMapsScriptLoader bootstrap；不另插入 script。
 */

import {
  __resetGoogleMapsLoaderForTests,
  __testExports,
  ensureGoogleMapsBootstrap,
  importGoogleMapsLibrary,
} from './googleMapsScriptLoader';

/**
 * 動態載入 Maps JavaScript API bootstrap，再 importLibrary('places')。
 * @param {string} apiKey browser key（不得 hardcode 於 production config）
 * @returns {Promise<{ AutocompleteSessionToken: Function, AutocompleteSuggestion: Object }>}
 */
export function loadGooglePlacesLibrary(apiKey) {
  return importGoogleMapsLibrary(apiKey, 'places');
}

export {
  ensureGoogleMapsBootstrap,
  importGoogleMapsLibrary,
  __resetGoogleMapsLoaderForTests,
  __resetGoogleMapsLoaderForTests as __resetGooglePlacesLoaderForTests,
  __testExports,
};
